module.exports = __webpack_public_path__ + "img/TaktNews-ProjectStructureOne.7f123123.png";